interface ManageVehicleTypesScope extends ng.IScope {
  body_types: Array<any>;
  groups    : Array<any>;
  loaded    : boolean;
}

export function ManageVehicleTypesCtrl (
  $scope    : ManageVehicleTypesScope,
  body_types: Array<any>,
  groups    : Array<any>
) {
  $scope.loaded = true;

  $scope.body_types = body_types.map(( type : any ) => {
    type.destroy = '0';

    return type;
  });

  $scope.groups = groups.map(( group : any ) => {
    group.destroy = '0';

    return group;
  });
}